import '../components/loader';
import {addInlineError, addErrorSummaryItem, updateTitleIfNotAlreadyInError} from './add-errors-clientside';

const isImageLoadedOrError = function(imgElement) {
    // 'complete' is true if the image has loaded or is broken
    // Many examples on the web add (naturalHeight !== 0) here to exclude broken images
    // but we want to turn off the spinner and re-enable the continue button in that case
    // so we haven't added it here.
    return imgElement.complete;
};

exports.photoCheck = function (
    loaderContainerId,
    loaderStyleElementId,
    signatureImageHref,
    loadingText,
    rotateErrorMessage,
    errorPhrase,
) {
    const loader = document.getElementById(loaderContainerId);
    const sigImage = document.getElementById('signature-image');
    const checkForm = document.getElementById("check-form");
    const continueButton = checkForm.querySelector('button[name="submit-button"]');
    const rotateButton = checkForm.querySelector('button[name="rotate-signature-button"]')
    const rotateContainer = document.getElementById('rotate');
    const jsErrorSummary = document.getElementById('js-check-image-error-summary');
    const jsErrorList = jsErrorSummary.querySelector('.govuk-error-summary__list');
    let numberOfRotationButtonClicks = 0;
    const spinner = new GOVUK.Loader();

    if (!isImageLoadedOrError(sigImage)) {
        showElement(loader);
        hideElement(sigImage);
        disableButton(continueButton);
        disableButton(rotateButton)
        spinner.init({
            container: loaderContainerId,
            styleElementId: loaderStyleElementId,
            label: true
        });
        spinner.updateMessage(loadingText);
        sigImage.addEventListener('load', imageOnLoad);
        setTimeout(() => enableButton(continueButton), 5000);
    }

    if (rotateButton) {
        rotateButton.type = "button";
        rotateButton.addEventListener('click', trackRotateButtonClicked);
        rotateButton.addEventListener('click', rotateSignature);
    }

    function rotateSignature() {
        hideElement(sigImage);
        showElement(loader);
        disableButton(rotateButton);
        disableButton(continueButton);
        spinner.init({
            container: loaderContainerId,
            styleElementId: loaderStyleElementId,
            label: true
        });
        numberOfRotationButtonClicks++;
        spinner.updateMessage(loadingText);

        var xhr = new XMLHttpRequest();
        xhr.onerror = rotateErrorHandler;
        xhr.onload = rotateCompleteHandler.bind(this, xhr);
        xhr.open('POST', document.location);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send("rotate-signature-button=rotate&js-rotate=true");
    }

    function trackRotateButtonClicked() {
        window.dataLayer && dataLayer.push({
            'event': 'event_data',
            'event_data': {
                'event_name': 'signature_rotate_button_clicked'
            },
        });
    }

    function rotateCompleteHandler(xhr) {
        try {
            if (xhr.status !== 200) {
                throw new Error("Error status from backend: " + xhr.status);
            }
            const body = JSON.parse(xhr.responseText);
            if (!body.success) {
                addRotateError(rotateErrorMessage)
            } else {
                clearRotateError();
            }
            sigImage.src = signatureImageHref + '?t=' + Date.now();
        } catch (e) {
            rotateErrorHandler(e);
        }
    }

    function rotateErrorHandler(e) {
        console.error(e);
        spinner.stop();
        hideElement(loader);
        showElement(sigImage);
        enableButton(rotateButton);
        enableButton(continueButton);
        addRotateError();
        // Measure to avoid people spamming the button as it sends requests to our servers.
        // Reloading the page re-enables the button
        if (numberOfRotationButtonClicks < 20) {
            enableButton(rotateButton);
        }
    }

    function hideErrorsOnPage() {
        const errorSummary = document.querySelector('.govuk-error-summary');
        if (errorSummary) errorSummary.style.display = 'none';

        const inlineErrors = document.querySelectorAll('.govuk-error-message');
        inlineErrors.forEach(error => {
            error.closest('.govuk-form-group')?.classList.remove('govuk-form-group--error');
            error.remove();
        });
    }

    function addRotateError() {
        hideErrorsOnPage();

        addInlineError(rotateContainer, rotateButton, "rotate-error", errorPhrase, rotateErrorMessage);
        rotateContainer.classList.add("govuk-form-group");
        jsErrorList.innerHTML = '';
        updateTitleIfNotAlreadyInError(errorPhrase);
        addErrorSummaryItem(jsErrorList, "rotate", rotateErrorMessage);

        jsErrorSummary.style.display = 'block';
        jsErrorSummary.focus();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    function clearRotateError() {
        const existingError = document.getElementById("rotate-error");
        if (existingError) existingError.remove();
        rotateContainer.classList.remove("govuk-form-group", "govuk-form-group--error");
        jsErrorList.innerHTML = '';
        jsErrorSummary.style.display = 'none';
    }

    function imageOnLoad() {
        hideElement(loader);
        spinner.stop();
        showElement(sigImage);
        enableButton(continueButton);
        enableButton(rotateButton);
    }

    function disableButton(button) {
        button.setAttribute('disabled', '');
        button.setAttribute('aria-disabled', true);
    }

    function enableButton(button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
    }

    function hideElement(element) {
        element.classList.add('hidden');
    }

    function showElement(element) {
        element.classList.remove('hidden');
    }
}

exports.isImageLoadedOrError = isImageLoadedOrError;
